import React from "react";
import { BookOpen, ArrowUpRight } from "@phosphor-icons/react";
import { useBlogLinks } from "@/lib/useBlogLinks";

export default function LatestGuides() {
  const blogLinks = useBlogLinks();
  const items = blogLinks.homeLatest || [];
  if (items.length === 0) return null;

  return (
    <section
      id="latest-guides"
      data-testid="latest-guides"
      className="bg-zinc-50 py-16 md:py-24 border-y border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-blue-600">
            <BookOpen size={16} weight="duotone" />
            Latest guides
          </div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-zinc-900">
            Real answers from our TechConnect blog
          </h2>
          <p className="mt-4 text-lg text-zinc-600 leading-relaxed">
            Deep-dive articles on pricing, city-by-city repair guides, and honest
            small-business IT reviews — written by our own techs.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((g, i) => (
            <a
              key={g.url}
              href={g.url}
              target="_blank"
              rel="noopener"
              data-testid={`latest-guide-${i}`}
              className="group relative flex flex-col justify-between bg-white border border-zinc-200 rounded-2xl p-7 hover:-translate-y-1 hover:shadow-xl hover:border-blue-300 transition-all duration-300"
            >
              <div>
                <div className="h-11 w-11 rounded-xl bg-blue-600/10 text-blue-600 grid place-items-center">
                  <BookOpen size={22} weight="duotone" />
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-zinc-900 leading-snug">
                  {g.label}
                </h3>
              </div>
              <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-blue-600 group-hover:gap-2 transition-all">
                Read the guide
                <ArrowUpRight size={14} weight="bold" />
              </span>
            </a>
          ))}
        </div>

        <div className="mt-10">
          <a
            href="https://blog.techconnectncllc.services"
            target="_blank"
            rel="noopener"
            data-testid="latest-guides-all"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-blue-600 hover:text-blue-700"
          >
            Browse all guides on our blog
            <ArrowUpRight size={14} weight="bold" />
          </a>
        </div>
      </div>
    </section>
  );
}
